<template>
  <chart-container
    :titleChart="titleChart"
    @onCSVDownload="downloadCsv(titleChart)"
    @zoomEnabled="zoomGraph(true)"
    @zoomDisabled="zoomGraph(false)"
    :downloadId="downloadId"
    :specificSiteId="specificSiteId"
    :zoomGraphValue="zoomGraphValue"
    :downloadShow="this.nullexpected"
    class="bg-gradient-blue"
    titleTooltip="This chart is intended to show overall participant progression through the study. Each participant is tracked through the study in relation to upcoming scheduled activities or study milestones, if defined. The chart provides insight to the study team to prepare for higher volumes of upcoming activities. Additionally, this metric intends to give a sense of the overall study progress and helps answer the following questions: Have most participants finished the study? Are most participants between certain milestones?"
    :tooltipHtmlContent="true"
    tooltipPlacement="bottom"
    :showThreadLogoInUnexpand="this.nullexpected"
  >
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs>
        <b-tab v-for="(tabName, index) in tabs" :key="index" :title="tabName" @click="tabChange(index)" />
      </b-tabs>
    </span>
    <fusioncharts style="width: 100%" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="siteDataPerformanceOverTime" v-if="this.nullexpected" slot="body" />
    <div slot="body" class="text-left min-height-0" v-if="this.nullexpected"></div>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data-down">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
import * as dManagement from "@/services/visualization/study-completion";
import ChartContainer from "./chart-container-dark-blue";
import * as utils from "../../services/visualization/utils";
import { downloadCSV } from "../../services/visualization/data-management";
export default {
  components: {
    ChartContainer
  },

  props: {
    titleChart: { type: String, default: "" },
    downloadId: { type: String, default: "" },
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: [Object, Array],
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    rawData: { type: [Object, Array], default: () => {} },
    rawData1: { type: [Object, Array], default: () => {} },
    dataLoaded: { type: Boolean, default: false },
    participantsSelected: [Array, String]
  },

  watch: {
    specificSiteId: function() {
      if (this.specificSiteId.length > 0) {
        this.tabs = ["Countries"];
        this.activeTabName = ["Countries"];
      }
    },
    rawData: function(newVal) {
      const response = dManagement.getParticipantStudyProgress(newVal, this.countrySelected, this.sitesSelected, this.rawData1, this.activeTabName);
      this.setGraphDataAndConfigs(response);
      this.rawdatafromdata = newVal;
      if (!(newVal == null)) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
    },
    rawData1: function(newVal) {
      const response = dManagement.getParticipantStudyProgress(this.rawData, this.countrySelected, this.sitesSelected, newVal, this.activeTabName);
      this.setGraphDataAndConfigs(response);
    },
    sitesSelected: function(newVal) {
      const response = dManagement.getParticipantStudyProgress(this.rawData, this.countrySelected, newVal, this.rawData1, this.activeTabName);
      this.setGraphDataAndConfigs(response);
    },
    zoomTrigger: function() {
      this.setGraphDataAndConfigs();
    },
    zoomGraphValue: function(newVal) {
      if (newVal == "") {
        this.height = "250";
      }
      if (newVal) {
        this.zoomTrigger = true;
      } else {
        this.zoomTrigger = false;
      }
    },
    participantsSelected: function(newVal) {
      if (newVal.length > 0 && this.rawdatafromdata) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
    },
    activeTabName: function(newVal) {
      const response = dManagement.getParticipantStudyProgress(this.rawData, this.countrySelected, this.sitesSelected, this.rawData1, newVal);
      this.setGraphDataAndConfigs(response);
    }
  },

  data() {
    return {
      nullexpected: null,
      rawdatafromdata: null,
      zoomTrigger: false,
      type: "bubble",
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: {
        chart: {
          theme: "fusion",
          palettecolors: utils.getColorPalette("gradient"),
          showyaxisvalues: "0",
          xAxisName: "Study Progression",
          xAxisNameFontColor: "#959fa4",
          showValues: "1",
          numDivlines: "0",
          xAxisMinValue: "0",
          plotFillAlpha: "70",
          use3dlighting: "0",
          showAlternateHGridColor: "0",
          showAlternateVGridColor: "0",
          showvalues: "0",
          labeldisplay: "stagger",
          xAxisNameFontSize: "9",
          xAxisNameFont: "RobotoMedium",
          labelFontSize: "10px",
          labelFont: "RobotoRegular",
          labelFontColor: "#a3a3a3",
          yAxisNameFontColor: "#a3a3a3",
          yAxisNameFontSize: "9",
          yAxisValueFontColor: "#a3a3a3",
          yAxisValueFontSize: "10",
          yAxisValueFont: "RobotoRegular",
          yAxisMinValue: "0",
          useEllipsesWhenOverflow: "1",
          maxColWidth: "42",
          plotSpacePercent: 30,
          plotHighlightEffect: "fadeout",
          showlegend: "1",
          legendposition: "bottom",
          minimiseWrappingInLegend: true,
          showXAxisLine: true,
          showYAxisLine: true,
          xaxislinethickness: "1",
          yaxislinethickness: "1",
          xAxisLineColor: "#b0bac9",
          yAxisLineColor: "#b0bac9",
          divLineAlpha: "0",
          bgAlpha: "0",
          baseFontColor: "#a3a3a3",
          baseFontSize: "10",
          legendItemFont: "Roboto",
          legendItemFontSize: "10",
          legendItemFontColor: "#b0bac9",
          scrollheight: "8",
          legendIconBorderThickness: "0.51",
          chartBottomMargin: "0",
          xAxisNamePadding: "10",
          trendvaluefont: "RobotoRegular",
          trendvaluefontsize: "11px",
          highlighteffect: "fadeout",
          yAxisNamePadding: "10",
          baseFont: "RobotoRegular",
          chartTopMargin: "20",
          numvisibleplot: "50",
          LabelDisplay: "rotate",
          canvasRightPadding: "1"
        },
        categories: [],
        dataset: [],
        vTrendlines: []
      },
      curZoomLevel: 0,
      maxZoomLevel: 2,
      tabs: ["Total", "Countries", "Sites"],
      activeTab: 0,
      activeTabName: "data_changes"
    };
  },

  methods: {
    zoomGraph(status) {
      if (status) {
        this.zoomTrigger = true;
        this.$emit("zoomEnabled");
      } else {
        this.zoomTrigger = false;
        this.$emit("zoomDisabled");
      }
      this.setGraphDataAndConfigs();
    },
    downloadCsv(titleChart) {
      setTimeout(() => {
        const header = ["Country", "Site", "Participant ID", "Days in Study", "Study Progression Average"];
        const newArr = [];
        const response = dManagement.getParticipantStudyProgress(this.rawData, this.countrySelected, this.sitesSelected);
        response.csvData.map(item => newArr.push([item.countrys, item.site, item.name, item.x, item.averageStudyProgressions]));
        downloadCSV(titleChart, header, newArr, this.specificSiteId);
      }, 1);
    },
    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = this.zoomTrigger ? 8 : 4.2;
          break;
        case 1:
          numVisPlot = this.zoomTrigger ? 7 : 3.2;
          break;
        case 2:
          numVisPlot = this.zoomTrigger ? 6 : 2.2;
          break;
        default:
          break;
      }
      return numVisPlot;
    },
    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.siteDataPerformanceOverTime.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.bubblescale = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.siteDataPerformanceOverTime.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.bubblescale = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    setGraphDataAndConfigs(response = null) {
      if (response) {
        const dataSources = _cloneDeep(this.dataSource);
        dataSources.categories[0] = { category: response.categories };
        dataSources.dataset[0] = { plotBorderHoverThickness: "1" };
        dataSources.vTrendlines = response.data[2];
        dataSources.categories = response.data[3];
        if (response.data[0].length > 0) {
          this.nullexpected = true;
        } else {
          this.nullexpected = false;
        }
        if (this.activeTabName == "Countries" || this.activeTabName == "Sites") {
          dataSources.dataset = response.data[0];
          dataSources.chart.plotTooltext = "$Seriesname{br}Participant: $name{br}Days in Study: $xvalue";
        } else {
          dataSources.dataset[0].data = response.data[0];
          dataSources.chart.plotTooltext = "Participant: $name{br}Days in Study: $xvalue";
        }
        if (response.csvData.length < 5) {
          dataSources.chart.bubblescale = 0.65;
        } else if (response.csvData.length < 10) {
          dataSources.chart.bubblescale = 0.55;
        } else if (response.csvData.length < 25) {
          dataSources.chart.bubblescale = 0.5;
        } else if (response.csvData.length < 50) {
          dataSources.chart.bubblescale = 0.4;
        } else if (response.csvData.length < 100) {
          dataSources.chart.bubblescale = 0.3;
        } else if (response.csvData.length < 200) {
          dataSources.chart.bubblescale = 0.2;
        } else if (response.csvData.length < 300) {
          dataSources.chart.bubblescale = 0.15;
        } else {
          dataSources.chart.bubblescale = 0.15;
        }
        this.dataSource = dataSources;
      }
      if (this.$refs.siteDataPerformanceOverTime) {
        const chartRef = this.$refs.siteDataPerformanceOverTime.chartObj;
        const data = chartRef.getJSONData();
        if (this.zoomTrigger) {
          data.chart.xAxisNameFontSize = "12";
          data.chart.xAxisValueFontSize = "12";
          data.chart.yAxisNameFontSize = "12";
          data.chart.yAxisValueFontSize = "12";
          data.chart.baseFontSize = "12";
          data.chart.numvisibleplot = "8";
          this.dataSource.chart.xAxisNameFontSize = "12";
          this.dataSource.chart.xAxisValueFontSize = "12";
          this.dataSource.chart.yAxisNameFontSize = "12";
          this.dataSource.chart.yAxisValueFontSize = "12";
          this.dataSource.chart.baseFontSize = "12";
          this.dataSource.chart.numvisibleplot = "8";
          this.height = "400";
        } else {
          data.chart.xAxisNameFontSize = "9";
          data.chart.xAxisValueFontSize = "10";
          data.chart.yAxisNameFontSize = "9";
          data.chart.yAxisValueFontSize = "10";
          data.chart.baseFontSize = "10";
          data.chart.numvisibleplot = "4.2";
          this.dataSource.chart.xAxisNameFontSize = "9";
          this.dataSource.chart.xAxisValueFontSize = "10";
          this.dataSource.chart.yAxisNameFontSize = "9";
          this.dataSource.chart.yAxisValueFontSize = "10";
          this.dataSource.chart.baseFontSize = "10";
          this.dataSource.chart.numvisibleplot = "4.2";
          this.height = "250";
        }
        chartRef.setJSONData(data);
      }
    },
    tabChange(newValue) {
      if (!(this.dataSource.dataset == 0)) {
        this.dataSource.dataset.splice(0, this.dataSource.dataset.length);
      }
      this.activeTab = newValue;
      if (newValue == 0) {
        this.activeTabName = "Total";
      } else if (newValue == 1) {
        this.activeTabName = "Countries";
      } else if (newValue == 2) {
        this.activeTabName = "Sites";
      }
    }
  }
};
</script>

<style lang="scss">
.bg-gradient-blue {
  .fusioncharts-container > svg {
    background-color: unset !important;
  }
}
</style>
